import { auth } from "../../core/auth";

/**
 * @deprecated use `auth.getAuthOrLogout().data` instead
 */
export default function useAuthData() {
  return auth.getAuthOrFail().data;
}
